import { PayloadAction } from "@reduxjs/toolkit";
import { ProposalState } from "..";

type SetProductRecallYParams = {
  formId: string;
  value: string;
};

function SetProductRecallYReducer(
  state: ProposalState,
  { payload: { formId, value } }: PayloadAction<SetProductRecallYParams>,
) {
  state.productByFormId[formId].commercialConditions.recallY = value;
}

export default SetProductRecallYReducer;
